import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { ADMINISTRATIVE_CHECKLIST_PATH } from '../../../../config/paths';
import IncidentRecordForm from './IncidentRecordForm';
import { INCIDENT_SCOPE_TYPE } from '../../../../config/constants';
import { tzMergeDateAndTime, tzNormalizeDate } from '../../../../utils/date';
import { TIME_FORMAT } from '../../../../config/locale';
import { getIncidentsAdministrativeForm } from '../../../../actions/supervision-control';
import { postIncidentRecord } from '../../../../actions/supervision-control/IncidentRecord';

const NewAdministrativeChecklist = ({
  breadcrumbs,
  dispatchGetIncidentsAdministrativeForm,
  dispatchPush,
  dispatchPostIncidentRecord,
}) => {
  const handleSubmit = async (formValues) => {
    const {
      incidentId,
      nodePathsPerRow,
      incidentItems,
      dateString,
      timeString,
      agency,
    } = formValues;

    const incidentDate = tzMergeDateAndTime({
      date: dateString,
      time: timeString,
    });

    if (!nodePathsPerRow || Object.keys(nodePathsPerRow).length === 0) {
      toastr.error(
        'Error',
        'Debe seleccionar al menos un nodo para el incidente',
      );
      return;
    }

    const answerList = incidentItems.flatMap((rowValues, rowIndex) => {
      const fieldPrefix = `incidentItems[${rowIndex}]`;
      const nodePath = nodePathsPerRow[`${fieldPrefix}.nodeSelector`] || [];

      return nodePath.map((node, pathIndex) => {
        const note = rowValues[`incidentNodeNote-${pathIndex}`] || null;
        const answer = { nodeId: node.id };
        if (note) answer.note = note;
        return answer;
      });
    });

    const payload = {
      incidentId,
      incidentDate,
      answerList,
      agencyId: agency ? agency.value : null,
    };

    await dispatchPostIncidentRecord(payload);
    dispatchPush(ADMINISTRATIVE_CHECKLIST_PATH);
  };

  const handleIncidentRecordTypeChange = (incidentRecordTypeForm) => {
    if (!incidentRecordTypeForm) return;
    const { value: incidentRecordType } = incidentRecordTypeForm;
    dispatchGetIncidentsAdministrativeForm({ incidentRecordType });
  };

  const content = (
    <IncidentRecordForm
      onSubmit={handleSubmit}
      incidentScope={INCIDENT_SCOPE_TYPE.ADMINISTRATIVE.value}
      handleIncidentRecordTypeChange={handleIncidentRecordTypeChange}
      initialValues={{
        dateString: tzNormalizeDate(),
        timeString: tzNormalizeDate({ format: TIME_FORMAT }),
      }}
      allowDuplicateNodes={false}
      label="Actividad"
    />
  );

  return (
    <Content
      title="Nuevo Checklist Administrativo"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  );
};

NewAdministrativeChecklist.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetIncidentsAdministrativeForm: PropTypes.func.isRequired,
  dispatchPush: PropTypes.func.isRequired,
  dispatchPostIncidentRecord: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Checklist Administrativo',
      href: ADMINISTRATIVE_CHECKLIST_PATH,
    },
    {
      text: 'Nuevo Checklist Administrativo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchGetIncidentsAdministrativeForm: getIncidentsAdministrativeForm,
  dispatchPush: push,
  dispatchPostIncidentRecord: postIncidentRecord,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewAdministrativeChecklist);
